import { MixpanelService } from "./providers/Mixpanel";

export const analyticsAdapter = {
  MixpanelService,
};
